import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["elite-distance-runners"]!;

export function Body() {
  return (
    <>
      <p>
        It is tempting to copy the best runners in the world. A 2022 review describes how
        world-class distance runners actually train, which makes it easier to see what a
        recreational runner can borrow and what belongs to a different life.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from Norway, including Stephen Seiler, combined published research with the
        documented practice of successful coaches and athletes. They described the training of
        world-leading 5,000 and 10,000 metre runners and marathon runners.
      </p>

      <h2>What they found</h2>
      <p>
        In the middle of the preparation period, marathon runners ran 160 to 220 km a week and
        track runners 130 to 190 km. Both groups trained 11 to 14 times a week, and at least 80
        percent of their running volume was at low intensity throughout the year.
      </p>
      <p>
        The amount of running at race pace increased as the main race came closer. The taper
        started 7 to 10 days before the main competition. Track runners raced about nine times a
        year, marathon runners about six. Many trained at altitude, either living there or
        through long training camps.
      </p>

      <h2>What it means for you</h2>
      <p>
        Two things carry over well. Most of the running is easy, also for the best in the world.
        And race-specific running increases as the race approaches, so the body gets used to the
        pace it will need on the day.
      </p>
      <p>
        The volume does not carry over. Elite runners build up to 11 to 14 sessions a week over
        many years, with sleep, recovery and support that most of us don't have. A short taper
        of 7 to 10 days also fits their high volume. Studies of recreational marathon runners
        point to a longer, steadier taper of around three weeks.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The review describes what the best runners do. It doesn't show that each element is the
        reason for their success, or what would happen if a recreational runner copied it.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training keeps most of your running easy and plans more race-specific running as
        your race gets closer. The amount and the taper are fitted to your own training, the
        time you have and your race distance.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Haugen et al. (2022), The training characteristics of world-class distance runners: an
          integration of scientific literature and results-proven practice.{" "}
          <a href="https://doi.org/10.1186/s40798-022-00438-7">Sports Medicine – Open</a>.
        </li>
      </ul>
    </>
  );
}
